import React, { useMemo } from 'react';

import { CustomerInformationInputType, InputType, CI_INPUT_MODE } from '../../types/common/CustomerInformationType';
import { Reasons, MasterInquireApiResponse } from '../../types/api/MasterInquireApiType';

import { ErrorMessage } from '../../components/ErrorMessage';

type CustomerInformationInputProps = {
    dataInput: InputType; // 入力モード
    cIInput: CustomerInformationInputType;
    setCIInput: (value: CustomerInformationInputType) => void;
    errorMessages: Array<string>;
    masterInquire: MasterInquireApiResponse; // お問い合わせ種別、お問い合わせ理由のマスタ
};

export const CustomerInformationInput: React.FC<CustomerInformationInputProps> = ({
    dataInput,
    cIInput,
    setCIInput,
    errorMessages,
    masterInquire,
}) => {
    // マスタ取得
    const reasonsType = useMemo<Array<Reasons>>(() => masterInquire.reasons, []);

    return (
        <>
            <div className='columns form-item_area is-multiline is-variable is-1-mobile is-1-tablet is-4-desktop is-6-widescreen is-6-fullhd'>
                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label required'>会社名</label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='text'
                                        placeholder='データライブ株式会社'
                                        value={cIInput?.company}
                                        onChange={(e) => setCIInput({ ...cIInput, company: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label required'>部署名</label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='text'
                                        placeholder='総務部'
                                        value={cIInput?.division}
                                        onChange={(e) => setCIInput({ ...cIInput, division: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label required'>お名前</label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='text'
                                        placeholder='データ　太郎'
                                        value={cIInput?.name}
                                        onChange={(e) => setCIInput({ ...cIInput, name: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label required'>ふりがな</label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='text'
                                        placeholder='でーた　たろう'
                                        value={cIInput?.kana}
                                        onChange={(e) => setCIInput({ ...cIInput, kana: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label required'>メールアドレス</label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='email'
                                        placeholder='taro@datalive.co.jp'
                                        value={cIInput?.mail}
                                        onChange={(e) => setCIInput({ ...cIInput, mail: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label required'>
                                メールアドレス
                                <br />
                                確認
                            </label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='email'
                                        placeholder='※コピー＆ペーストせずにご入力ください'
                                        value={cIInput?.mailReInput}
                                        onChange={(e) => setCIInput({ ...cIInput, mailReInput: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='column is-6-desktop is-12-touch'>
                    <div className='field is-horizontal'>
                        <div className='field-label is-normal'>
                            <label className='label optional'>電話番号</label>
                        </div>
                        <div className='field-body'>
                            <div className='field'>
                                <p className='control is-expanded'>
                                    <input
                                        className='input'
                                        type='tel'
                                        placeholder='090-1234-5678'
                                        value={cIInput?.phone}
                                        onChange={(e) => setCIInput({ ...cIInput, phone: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ci_alert'>
                {errorMessages.length !== 0 &&
                    errorMessages.map((error, index) => {
                        return (
                            <div key={`ci-input-alert-${index}`}>
                                <ErrorMessage errorMessage={error} />
                            </div>
                        );
                    })}
            </div>
            <hr />
            <div className='columns form-item_area is-multiline is-variable is-1-mobile is-1-tablet is-4-desktop is-6-widescreen is-6-fullhd'>
                <div className='column '>
                    <div className='field'>
                        <div className='label is-normal'>
                            <label className='label optional'>アンケート「当社を知ったきっかけ」</label>
                        </div>
                        <p className='help questionnaire'>よろしければご回答ください。</p>
                        <div className='field-body'>
                            <div className='field questionnaire'>
                                <div className='control'>
                                    {reasonsType &&
                                        reasonsType.map((reason, index) => (
                                            <label className='radio' key={`reason-${index}`}>
                                                <input
                                                    type='radio'
                                                    name='answer'
                                                    value={reason.reason_id}
                                                    checked={cIInput?.reasonId === reason.reason_id.toString()}
                                                    onChange={(e) =>
                                                        setCIInput({ ...cIInput, reasonId: e.target.value })
                                                    }
                                                    disabled={dataInput === CI_INPUT_MODE.READ}
                                                />
                                                {reason.reason_name}
                                            </label>
                                        ))}
                                </div>
                                <div className='control'>
                                    <textarea
                                        className='textarea'
                                        rows={1}
                                        placeholder='メディア名、その他詳細'
                                        value={cIInput?.reasonComment}
                                        onChange={(e) => setCIInput({ ...cIInput, reasonComment: e.target.value })}
                                        disabled={dataInput === CI_INPUT_MODE.READ}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {dataInput !== CI_INPUT_MODE.WRITE && (
                <>
                    <hr />
                    <div className='columns form-item_area is-multiline is-variable is-1-mobile is-1-tablet is-4-desktop is-6-widescreen is-6-fullhd'>
                        <div className='column '>
                            <div className='field is-horizontal p_poly'>
                                <div className='field'>
                                    <div className='control'>
                                        <label className='label required'>個人情報保護方針の同意</label>
                                        <label className='checkbox'>
                                            <input
                                                type='checkbox'
                                                onChange={(e) =>
                                                    setCIInput({ ...cIInput, pPolicyCheck: e.target.checked })
                                                }
                                                checked={cIInput?.pPolicyCheck}
                                                disabled={dataInput === CI_INPUT_MODE.READ}
                                            />
                                        </label>
                                        同意する
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
